import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import RequestAccessPage from './pages/RequestAccessPage';
import SurveyFixatePage from './pages/SurveyFixatePage';
import VerifyPage from './pages/VerifyPage';
import DashboardLayout from './pages/DashboardLayout';
import './App.css';

const API = process.env.REACT_APP_BACKEND_URL;

export { API };

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/request-access" element={<RequestAccessPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/survey-fixate" element={<SurveyFixatePage />} />
        <Route path="/verify/:hash" element={<VerifyPage />} />
        <Route path="/app/*" element={<DashboardLayout />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
